import { IStatus } from "entities/Account/api/models";
import React from "react";
import s from "./style.module.scss";
import { Status } from "shared/ui/Status";

export const Item: React.FC<IStatus> = ({
  title,
  color,
  subtitle1,
  subtitle2,
  description,
}) => {
  return (
    <li className={s.item}>
      <div className={s.top}>
        <Status color={color} type={title} />

        <span>{subtitle1}</span>
      </div>

      <p className={s.text}>{subtitle2}</p>

      <span className={s.notion}>{description}</span>
    </li>
  );
};
